import batteryLevelTemplate from './batteryLevel.html';
import './batteryLevel.scss';

export default angular
  .module('main.devices.edit.components.batteryLevel', [])

  .directive('batteryLevel', () => {
    return {
      restrict: 'E',
      template: batteryLevelTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceBatteryStatusResource.init()
          ])
            .then(() => {

            });

          $scope.$watch('dataProvider.deviceBatteryStatusResource.value', () => {
            $scope.batteryLevel = $scope.dataProvider.deviceBatteryStatusResource.value;
            $scope.batteryIcon = getBatteryIcon();
          });
        }

        function getBatteryIcon() {
          if (!$scope.batteryLevel && $scope.batteryLevel !== 0) {
            return;
          }

          let result = 'battery-empty';
          let value = angular.copy($scope.batteryLevel);
          switch (true) {
            case (value > 99):
              result = 'battery-full';
              break;
            case (value > 74):
              result = 'battery-three-quarters';
              break;
            case (value > 49):
              result = 'battery-half';
              break;
            case (value > 24):
              result = 'battery-quarter';
              break;
          }
          return result;
        }
      }
    };
  })
  .name;
